module.exports = __webpack_public_path__ + "static/media/eden.e3f58853.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/eden.jpg
 ** module id = 427
 ** module chunks = 0
 **/